import { GooglePlayUrl, isInsideAppleAppStoreApp } from '../../util/billing.ts';
import { OuterPageContent } from '../../util/shared.tsx';
import { Footer } from '../footer.tsx';
import { Header } from '../header.tsx';
import { PrimaryButton } from './learn_buttons.tsx';
import { PromptSubtext, ScreenBody, ScreenPrompt, Slack } from './learn_screen_parts.tsx';

// What the Learn tab shows inside a store app older than 24.0 (issue #3821), in place of the hub and
// every exercise: those apps cannot grant the microphone, and 24.0 is in the App Store and on Google
// Play. Only a store app ever shows it (see learn_visibility.ts).

// The App Store page as an iOS 4.x app can open it. Those apps keep any navigation to a host
// containing "apple.com" inside their web view (WebView.swift decidePolicyFor), where the App Store's
// web page cannot hand off to the App Store. Their check is case-sensitive, and WebKit lowercases the
// host of an https URL but leaves the host of an itms-apps URL as written, so this host gets past the
// check: the app passes the URL to UIApplication.open, and iOS opens the App Store on our page.
export const OldIOSAppStoreUrl = 'itms-apps://APPS.APPLE.COM/app/id1483413949';

// Where the update button goes: the App Store from an old iOS app, Google Play from an old Android
// app. Google Play's own https link is enough there: the Android app before 24.0 sets no
// WebViewClient on its WebView (MainActivity.java), so Android hands every navigation to the system,
// and the Play Store app opens its link.
export function getUpdateAppUrl(): string {
  return isInsideAppleAppStoreApp() ? OldIOSAppStoreUrl : GooglePlayUrl;
}

export const learnUpdateAppScreenId = 'learn-update-app';
export const learnUpdateAppButtonId = 'learn-update-app-button';

export const LearnUpdateAppPage = () => (
  <OuterPageContent>
    <Header title="Learn" showProfileAvatar />
    <LearnUpdateAppScreen />
    <Footer />
  </OuterPageContent>
);

// Presentational, so a story can show it without an old app's user agent
export const LearnUpdateAppScreen = () => (
  <ScreenBody id={learnUpdateAppScreenId}>
    <ScreenPrompt $widthInChars={20}>Update the app to use Learn</ScreenPrompt>
    <PromptSubtext>Learn's pitch and rhythm exercises need the newest version of Sing Your Part.</PromptSubtext>
    <Slack />
    <PrimaryButton
      id={learnUpdateAppButtonId}
      data-testid={learnUpdateAppButtonId}
      onClick={() => {
        window.location.href = getUpdateAppUrl();
      }}
    >
      Update the app
    </PrimaryButton>
  </ScreenBody>
);
